import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import Home from './Home'
import NotFound from './NotFound'
import AuthRoutes from './Auth'
import CategoriesRoutes from './Categories'
import CustomersRoutes from './Customers'
import DailyProductsRoutes from './DailyProducts'
import OptionsRoutes from './Options'
import OrdersRoutes from './Orders'
import ProductsRoutes from './Products'
import RecurringOrdersRoutes from './RecurringOrders'
import ReportsRoutes from './Reports'
import RoutesRoutes from './Routes'
import TypesRoutes from './Types'
import UomsRoutes from './Uoms'
import UsersRoutes from './Users'

export const createRoutes = (store) => ({
  path: '/',
  component: CoreLayout,
  indexRoute: Home(store),
  getChildRoutes (partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, [
        NotFound,
        ...AuthRoutes(store),
        ...CategoriesRoutes(store),
        ...CustomersRoutes(store),
        ...DailyProductsRoutes(store),
        ...OptionsRoutes(store),
        ...OrdersRoutes(store),
        ...ProductsRoutes(store),
        ...RecurringOrdersRoutes(store),
        ...ReportsRoutes(store),
        ...RoutesRoutes(store),
        ...TypesRoutes(store),
        ...UomsRoutes(store),
        ...UsersRoutes(store)
      ])
    })
  }
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js